module.exports = __webpack_public_path__ + "static/media/core_3.de29f69a.png";